(function ($) {
	$.weatherBug = function (element, options) {
		// **************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			WeatherBug = (function ($c, o) {
				var defaults = {

				}; 

				var _o = {}

				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);
					
				},

				_BindEvents = function () {
					$c.click(_OnLinkClick);
				},

					_OnLinkClick = function(e) {
						e.preventDefault();

						window.open('https://weather.com/weather/today/l/AZLKPLES:13:US');
					},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.weatherBug = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('weatherBug')) {
				var plugin = new $.weatherBug(this, options);
				$(this).data('weatherBug', plugin);
			}
		});
	};
})(jQuery);
